import React, {Component} from 'react';
import {
  Nav,
  NavItem
} from 'reactstrap';
import {NavLink} from 'react-router-dom';
import ManageDropdown from './ManageDropdown';

// Helper
import {
  checkBackend,
  checkFrontend,
  checkDoSurveys
} from '../../components/Authorization'


class MainNav extends Component {

  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false
    };
  }

  renderContactUsMenu() {
    if ( checkFrontend(this.props.state) ) {
      return (
        <NavItem className="px-3">
          <NavLink to="/support">Support</NavLink>
        </NavItem>
      );
    }
  }

  renderDoSurveyMenu() {
    if ( checkDoSurveys(this.props.state) ) {
      return (
        <NavItem className="px-3">
          <NavLink to="/my-surveys">My Surveys</NavLink>
        </NavItem>
      );
    }
  }

  renderManageDropdown() {
    if ( checkBackend(this.props.state) ) {
      return (
        <ManageDropdown />
      );
    }
  }

  render() {
    return (
      <Nav className={this.props.className} navbar>
        <NavItem className="px-3">
          <NavLink to="/account/profile">Account</NavLink>
        </NavItem>
        {this.renderDoSurveyMenu()}
        {this.renderContactUsMenu()}
        {this.renderManageDropdown()}
      </Nav>
    );
  }
}

export default MainNav;



// WEBPACK FOOTER //
// ./src/components/Header/MainNav.js